module.exports = __webpack_public_path__ + "static/media/tlyfe@2x.1bafe4bb.png";